import styled from 'styled-components';

export const Base = styled.div`
	margin-left: 12px;
	margin-right: 8px;
	padding: 4px 8px;
	font-size: 14px;
	font-family: 'Inter', sans-serif;
	color: ${({ theme }) => theme.gray[1000]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 4px;
	display: flex;
	align-items: center;
	gap: 6px;
	background: 'transparent';
	user-select: none;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const Text = styled.div`
	margin-right: 8px;
	font-size: 14px;
	font-family: 'Inter', sans-serif;
	color: ${({ theme }) => theme.gray[1000]};
	display: flex;
	align-items: center;
	gap: 6px;
`;

export const StatusIndicator = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;

	a {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		cursor: default;
		pointer-events: auto;
		width: 14px;
		height: 14px;
	}
`;
